import { withExperiments as experimetnsInjector } from '@wix/wix-experiments-react';
export const withExperiments = (component) => experimetnsInjector(component);
//# sourceMappingURL=with-experiments.js.map